import script from "./HeaderIconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderIconButton.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderIconButton.vue?vue&type=style&index=0&id=3aa6fe01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa6fe01"]])

export default __exports__